import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useAuth } from '../../contexts/AuthContext';

export const Login: React.FC = () => {
  const { signInWithGoogle, authError, clearAuthError } = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const hash = window.location.hash;
    const search = window.location.search;
    if (hash.includes('error=') || search.includes('error=')) {
      const params = new URLSearchParams(search || hash.substring(1));
      const errorDesc = params.get('error_description') || params.get('error') || 'Échec de la connexion avec Google.';
      setError(decodeURIComponent(errorDesc.replace(/\+/g, ' ')));
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  const handleGoogleSignIn = async () => {
    try {
      setError('');
      clearAuthError();
      setLoading(true);
      await signInWithGoogle();
    } catch (err: any) {
      console.error('Erreur de connexion Google:', err);
      setError('Échec de la connexion avec Google.');
      setLoading(false);
    }
  };

  const displayError = error || authError;

  return (
    <div className="min-h-screen bg-[#110a10] text-[#f2f0f2] flex flex-col justify-center items-center px-5 selection:bg-[#ff154d]/30 relative overflow-hidden" style={{ fontFamily: "'Oxanium', sans-serif" }}>
      <style>
        {`@import url('https://fonts.googleapis.com/css2?family=Lekton:wght@400;700&family=Oxanium:wght@400;500;600;700;800&display=swap');`}
      </style>

      {/* Ambient glowing background */}
      <div className="fixed inset-0 pointer-events-none z-0" style={{ backgroundImage: 'radial-gradient(circle at 50% 50%, #ff154d1a 0%, #0000 50%)' }}></div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-sm relative z-10"
      >
        <div className="text-center mb-10">
          <h1 className="text-[42px] font-bold tracking-tight text-white flex items-center justify-center">
            Zeyo<span className="text-[#ff154d] ml-1">✧</span>
          </h1>
          <p className="text-[#a89ea6] mt-2">Connectez-vous pour accéder à vos finances.</p>
        </div>

        <div className="bg-[#171118] border border-[#2d2230] rounded-3xl p-6 shadow-2xl">
          {displayError && (
            <div className="bg-[#ff154d]/10 border border-[#ff154d]/30 text-[#ff154d] p-3 rounded-xl mb-4 text-[13px] font-bold text-center">
              {displayError}
            </div>
          )}
          
          <button
            onClick={handleGoogleSignIn}
            disabled={loading}
            className="w-full bg-white hover:bg-gray-200 text-[#110a10] font-bold py-4 rounded-xl shadow-[0_0_15px_rgba(255,255,255,0.2)] transition-all flex justify-center items-center disabled:opacity-50 cursor-pointer"
          >
            <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24">
              <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
            {loading ? 'Connexion en cours...' : 'Se connecter avec Google'}
          </button>
        </div>
      </motion.div>
    </div>
  );
};

